import React from 'react';

const Header = () => {
    // Al retornar null, el componente existe pero no pinta nada en pantalla
    return null;
};

export default Header;